import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { homeBreadcrumbItem, useBreadcrumbsService } from 'shared/UI/UIKit/Breadcrumbs';
import { getScheduleForWeekUrl } from 'services/navigation';
import { getScheduleConfigurationById } from 'services/api';
import type { Curriculum } from 'services/api/educationPlans';
import type { ConfigurationSchedulesPageParams } from 'services/navigation';

const getEducationPlanSchedulesBreadcrumbs = (configurationName: string) => {
  return [
    homeBreadcrumbItem,
    {
      title: 'Расписание на неделю',
      url: getScheduleForWeekUrl(),
    },
    {
      title: configurationName,
      url: '',
    },
  ];
};

export const useEducationPlanSchedulesPage = () => {
  const { configurationId } = useParams<ConfigurationSchedulesPageParams>();
  const breadcrumbsService = useBreadcrumbsService();
  const [educationPlan, setEducationPlan] = useState<Curriculum | null>(null);

  useEffect(() => {
    if (configurationId) {
      breadcrumbsService.setBreadcrumbsLoading(true);

      getScheduleConfigurationById(Number(configurationId))
        .then((res) => {
          setEducationPlan(res);
          breadcrumbsService.setBreadcrumbs(getEducationPlanSchedulesBreadcrumbs(res.name));
        })
        .finally(() => {
          breadcrumbsService.setBreadcrumbsLoading(false);
        });
    }
  }, [configurationId]);

  return {
    breadcrumbs: breadcrumbsService.breadcrumbs,
    breadcrumbsLoading: breadcrumbsService.breadcrumbsLoading,
    educationPlan,
  };
};
